import {
	extend,
	// configure,
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
// import { i18n } from "./i18n";

// configure({
//   defaultMessage: (field, values) => {
//     // override the field name.
//     values._field_ = i18n.t(field);
//     return i18n.t(`validation.${values._rule_}`, values);
//   }
// });

for (let rule in rules) {
	extend(rule, {
		...rules[rule],
	});
}

extend('phone', {
	validate(value) {
		if (!value || value.length === 0) {
			return true;
		}
		
		// Primary validation: Use intl-tel-input's built-in validation
		// This ensures consistency with the PhoneInput component
		if (typeof window !== 'undefined' && window.intlTelInput && window.intlTelInputUtils) {
			try {
				const tempInput = document.createElement('input');
				tempInput.type = 'tel';
				document.body.appendChild(tempInput);
				
				const tempIti = window.intlTelInput(tempInput, {
					utilsScript: window.intlTelInputUtils
				});
				
				tempIti.setNumber(value);
				const isValid = tempIti.isValidNumber();
				
				// Clean up DOM
				tempIti.destroy();
				document.body.removeChild(tempInput);
				
				return isValid;
			} catch (error) {
				// Fall back to basic validation if library fails
			}
		}
		
		// Fallback validation when intl-tel-input is unavailable
		let cleanedPhone = value.replace(/[\s\-().]/g, '');
		if (/^0[1-9]\d{8,10}$/.test(cleanedPhone)) {
			cleanedPhone = cleanedPhone.slice(1);
		}
		if (cleanedPhone.length < 7 || cleanedPhone.length > 17) {
			return false;
		}
		const internationalPattern = /^(\+?[1-9]\d{1,4})?[1-9]\d{4,14}$/;
		return internationalPattern.test(cleanedPhone);
	},
	message: 'Please enter a valid phone number'
});

extend('partial_date', {
	validate(value) {
		if (!value || value.length === 0) {
			return true;
		}

		const v = value.toString().trim();

		// ISO date/timestamp (prefilled values that were not touched)
		if (/^\d{4}-\d{2}-\d{2}(T.*)?$/.test(v)) {
			return true;
		}

		if (/^\d{4}$/.test(v)) {
			return true;
		}

		const monthYear = v.match(/^(\d{1,2})[./-](\d{4})$/);
		if (monthYear) {
			return Number(monthYear[1]) >= 1 && Number(monthYear[1]) <= 12;
		}

		const dayMonthYear = v.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
		if (dayMonthYear) {
			return (
				Number(dayMonthYear[1]) >= 1 &&
				Number(dayMonthYear[1]) <= 31 &&
				Number(dayMonthYear[2]) >= 1 &&
				Number(dayMonthYear[2]) <= 12
			);
		}

		return false;
	},
	message: 'Please enter a valid date (2016, 05.2016 or 01.05.2016)'
});

extend('email_enhanced', {
	validate(value) {
		if (!value || value.length === 0) {
			return true;
		}
		
		const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
		
		if (value.length > 254) {
			return false;
		}
		
		const parts = value.split('@');
		if (parts.length !== 2) {
			return false;
		}
		
		const [localPart, domainPart] = parts;
		if (localPart.length > 64 || localPart.length === 0) {
			return false;
		}
		
		if (domainPart.length > 253 || domainPart.length === 0) {
			return false;
		}
		
		return emailRegex.test(value);
	},
	message: 'Please enter a valid email address'
});
